import { render } from "./ManageFavorites.vue?vue&type=template&id=353dc3e8&scoped=true"
import script from "./ManageFavorites.vue?vue&type=script&lang=js"
export * from "./ManageFavorites.vue?vue&type=script&lang=js"

import "./ManageFavorites.vue?vue&type=style&index=0&id=353dc3e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353dc3e8"]])

export default __exports__